import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIcon, Tooltip } from '@mantine/core';
const sizes = ['xs', 'md', 'xl'];
export const MRT_ToggleDensePaddingButton = (_a) => {
    var _b;
    var { table } = _a, rest = __rest(_a, ["table"]);
    const { getState, options: { icons: { IconBaselineDensityLarge, IconBaselineDensityMedium, IconBaselineDensitySmall, }, localization, }, setDensity, } = table;
    const { density } = getState();
    const handleToggleDensePadding = () => {
        var _a;
        setDensity((_a = sizes[(sizes.indexOf(density) - 1) % sizes.length]) !== null && _a !== void 0 ? _a : 'xl');
    };
    return (_jsx(Tooltip, { withinPortal: true, label: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleDensity, children: _jsx(ActionIcon, Object.assign({ "aria-label": localization.toggleDensity, onClick: handleToggleDensePadding, size: "lg" }, rest, { title: undefined, children: density === 'xs' ? (_jsx(IconBaselineDensitySmall, {})) : density === 'md' ? (_jsx(IconBaselineDensityMedium, {})) : (_jsx(IconBaselineDensityLarge, {})) })) }));
};
//# sourceMappingURL=MRT_ToggleDensePaddingButton.js.map